import React, { Component, Fragment } from 'react'
import { Modal, ModalHeader, ModalBody, ModalFooter, Alert } from 'reactstrap'
import lodash from 'lodash'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'

import Form from '../../../../1stlog-ui/src/components/Form'
import Checkbox from '../../../../1stlog-ui/src/components/Checkbox'
import Field, { Readonly } from 'components/Field'
import FilePicker from 'components/FilePicker'
import LoaderOverlay from 'components/LoaderOverlay'
import Result from './Result'
import { requestImport, set } from '../actions'
import {
  makeSelectIsLoading,
  makeSelectResult,
  makeSelectError,
  makeSelectIsOpen,
  makeSelectIsImport,
} from '../selectors'

const validateFile = (value) => (!value ? 'Ungültige Datei' : null)

class Import extends Component {
  constructor(props) {
    super(props)
    this.state = {
      file: undefined,
    }
  }

  componentWillReceiveProps(nextProps, nextState) {
    if (!this.props.isOpen && nextProps.isOpen) {
      this.setState(
        {
          file: undefined,
        },
        () => {}
      )
    }
  }

  setForm = (form) => {
    this.setState({ form })
  }

  submit = () => {
    const { result, requestImport } = this.props
    if (result && lodash.get(result, 'values.preview')) {
      requestImport({ ...result.values, preview: false })
    } else {
      this.state.form.submit()
    }
  }

  onSubmit = (values) => {
    const { requestImport } = this.props
    values.file = this.state.file
    requestImport(values)
  }

  preventSubmit = (e) => e.preventDefault()

  close = () => {
    const { result } = this.props
    this.props.set({
      isOpen: false,
      reload: result && result.entriesSaved,
    })
    this.state.form.reset()
  }

  drop = (accepted, rejected) => {
    if (lodash.get(accepted, 'length', 0) === 1) {
      const file = lodash.first(accepted)
      this.setState({ file }, () => {
        this.state.form.change('file', file)
      })
    }
  }

  fileState = (state) => {
    console.log('fileState')
    return state.file ? (
      <div className="mt-2">
        <b>Dateiname: {lodash.get(this.state.file, 'name', 'Unbekannt')}</b>
      </div>
    ) : null
  }

  render() {
    const { isOpen, isImport, result, error, isLoading } = this.props

    const { values: { preview } = {} } = result || {}

    return (
      <Form onSubmit={this.onSubmit} setForm={this.setForm}>
        <Modal isOpen={isOpen && isImport} toggle={this.close} size="lg">
          <ModalHeader>{i18n.t('import_csv', 'CSV importieren')}</ModalHeader>
          <div style={{ position: 'relative' }}>
            <LoaderOverlay isLoading={isLoading} />
            <ModalBody>
              {!!error && (
                <Alert color="danger">
                  {i18n.t(
                    'a_mistake_has_acurred_was_sent_to_developer_please_try_again', 
                    'Ein Fehler ist aufgetreten. Dieser wurde den Entwicklern gemeldet. Bitte versuchen Sie es erneut.')}
                  <br />
                  <div className="text-muted">({lodash.get(error, 'message')})</div>
                </Alert>
              )}
              <div>
                {!result && !error && (
                  <form
                    onSubmit={this.preventSubmit}
                    id="Import/form"
                    noValidate
                    className="needs-validation"
                  >
                    <div>
                      <Alert color="info">
                        <strong>{i18n.t('please_note:', 'Bitte beachten:')}</strong>
                        <br />
                        <div>
                            {i18n.t('when_importing_the_header_line_must_match_the_template', 'Beim Import muss die Headerzeile mit der Vorlage übereinstimmen.')}
                            {i18n.t('dowmload_template_here', 'Laden Sie die Vorlage hier herunter')}{' '}
                          <a href="/vorlage.csv" target="_blank">
                            <i className="far fa-external-link-alt" /> 
                          </a>{' '}
                        </div>
                      </Alert>
                      <div className="row">
                        <div className="col-sm-12">
                          <Field
                            name="file"
                            validate={validateFile}
                            onChange={(v) => this.setState({ file: v })}
                          >
                            <FilePicker />
                          </Field>
                        </div>
                      </div>
                      <div className="row mt-1">
                        <div className="col-sm-12">
                          <Field name="importDublicates">
                            <Checkbox>{i18n.t('allow_duplicates', 'Duplikate zulassen')}</Checkbox>
                          </Field>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-sm-12">
                          <Field name="preview">
                            <Checkbox>{i18n.t('display_view_first', 'Zunächst eine Vorschau anzeigen')}</Checkbox>
                          </Field>
                        </div>
                      </div>
                    </div>
                  </form>
                )}
                {result && <Result result={result} />}
              </div>
            </ModalBody>
            <ModalFooter>
              <button
                className="btn btn-light waves-effect waves-light"
                type="button"
                onClick={this.close}
              >
                {result && !lodash.get(result, 'values.preview') ? i18n.t('close', 'Schliessen') : i18n.t('cancel', 'Abbrechen')}
              </button>
              <Readonly name="preview">
                {(isPreview) => (
                  <button
                    hidden={result && !preview && !error}
                    className="btn btn-primary waves-effect waves-light"
                    type="button"
                    onClick={this.submit}
                  >
                    {result ? i18n.t('confirm', 'Bestätigen') : isPreview ? i18n.t('continue', 'Weiter') : i18n.t('import', 'Importieren')}
                  </button>
                )}
              </Readonly>
            </ModalFooter>
          </div>
        </Modal>
      </Form>
    )
  }
}

export default connect(
  createStructuredSelector({
    isLoading: makeSelectIsLoading(),
    isOpen: makeSelectIsOpen(),
    result: makeSelectResult(),
    error: makeSelectError(),
    isImport: makeSelectIsImport(),
  }),
  { requestImport, set }
)(Import)
